import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import ViewFundReportFunctional from './index.function';
import ViewReverse from '../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { ActionButtons } from './component';
import LoaderModal from '../../components/LoaderModal';
import TermsModal from '../../components/TermsModal';

const ViewFundReport = () => {
  const {
    TextWeight,
    navigate,
    isArabic,
    direction,
    state,
    onPressView,
    fund_loading,
    pdfUrl,
    setShowModal,
    showModal,
    onPressDownload,
    onPressEmail
  } = ViewFundReportFunctional();

  return (
    <div className='min-h-full'>
      <ViewReverse className={'gap-5 items-center'}>
        <ReactSVG
          src={icons?.backSmall}
          className={`cursor-pointer ${isArabic ? 'rotate-180' : ''}`}
          onClick={() => navigate(-1)}
        />
        <Text
          text={state?.fundReportTypeName}
          color='text-black'
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>
      <div className='border border-grey rounded-xl mt-8 py-5 px-5 shadow-light'>
        <div dir={direction} className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
          {state?.reports?.map((item, index) => (
            <ViewReverse
              key={index}
              className='flex flex-col border border-grey rounded-2xl p-4 gap-3 flex-1'
            >
              <div className='flex flex-col gap-1'>
                <Text
                  text={item?.reportName}
                  color='text-black'
                  size={fontSizes.h14}
                  weight={TextWeight.bold}
                />
              </div>

              <ActionButtons
                onPressView={() => onPressView(item)}
                onPressDownload={() => onPressDownload(item)}
                onPressEmail={() => onPressEmail(item)}
              />
            </ViewReverse>
          ))}
        </div>
      </div>
      
      <TermsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        src={pdfUrl?.payload}
        title={pdfUrl?.fileName}
      />
      <LoaderModal open={fund_loading} />
    </div>
  );
};

export default ViewFundReport;
